import React from 'react';

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import { YatCheckoutForm } from '@pkg/components';

import config from '@app/config';

const stripePromise = loadStripe(config.stripeKey);
interface Props {
    onSelectCrypto: (isCrypto: boolean) => void;
    switchFromCrypto: boolean;
}
export const YatCheckoutContainer = ({ onSelectCrypto, switchFromCrypto }: Props) => {
    return (
        <Elements stripe={stripePromise}>
            <YatCheckoutForm onSelectCrypto={onSelectCrypto} switchFromCrypto={switchFromCrypto} />
        </Elements>
    );
};
